// External Libraries
import * as React from "react";

// UITK
import { UitkLink } from "uitk-react-link";

// Types
import { FilterPill } from "src/components/flexComponents/Hotels/typings";

// Utils
import { getHSRStarRatingCode } from "components/utility/ContextUtil";

// Components
import { HotelAffinityFilters } from "components/flexComponents/Hotels/components/HotelAffinityFilters/HotelAffinityFilters";
import { TrackedLink } from "src/components/utility/analytics/TrackedLink";
import { useLocalization } from "@shared-ui/localization-context";
import { useHotelsContext } from "components/flexComponents/Hotels/components/HotelsContext";

/**
 * @description
 * HotelStarRatingAffinityFilters: Specific Component Filters to Star Rating Affinity Pages
 */
export const HotelStarRatingAffinityFilters: React.FC<{}> = () => {
  const {
    context,
    flexComponent: { model, name: moduleName },
  } = useHotelsContext();
  const { formatText } = useLocalization();

  const pageStarRating = getHSRStarRatingCode(context);

  if (!pageStarRating) {
    return null;
  }

  const { searchContext } = context;

  const regionName: string = searchContext?.location?.name;

  const filterPills: FilterPill[] = [
    {
      label: formatText("themeSelector.affinity.pool"),
      queryFilter: `&star=${pageStarRating}&amenities=POOL`,
      key: "affinity-filter-pool",
    },
    {
      label: formatText("themeSelector.affinity.spa"),
      queryFilter: `&star=${pageStarRating}&amenities=SPA_ON_SITE`,
      key: "affinity-filter-spa",
    },
    {
      label: formatText("themeSelector.affinity.hottub"),
      queryFilter: `&star=${pageStarRating}&amenities=HOT_TUB`,
      key: "affinity-filter-hottub",
    },
    {
      label: formatText("amenities.description.breakfastIncluded"),
      queryFilter: `&star=${pageStarRating}&amenities=FREE_BREAKFAST`,
      key: "affinity-filter-breakfast",
    },
    {
      label: formatText("themeSelector.affinity.waterpark"),
      queryFilter: `&star=${pageStarRating}&amenities=WATER_PARK`,
      key: "affinity-filter-waterpark",
    },
  ];

  return (
    <section className="uitk-type-center all-t-margin-four">
      <p className="uitk-type-heading-300">{formatText("hotels.affinity.starRating.looking.for")}</p>
      <div className="uitk-type-300 all-b-margin-three">
        <UitkLink inline={true}>
          <TrackedLink
            moduleName={moduleName}
            href={model.seeAllLink}
            rfrr={model.seeAllType}
            linkName={model.seeAllLink}
            rel="nofollow"
          >
            {formatText("hotels.affinity.starRating.see.all", regionName)}
          </TrackedLink>
        </UitkLink>
        <div>{formatText("hotels.affinity.starRating.find.more")}</div>
      </div>
      <HotelAffinityFilters filters={filterPills} />
    </section>
  );
};
